import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface ContinueButtonProps {
  onContinue: () => void;
  disabled: boolean;
  disabledMessage?: string;
}

const ContinueButton = ({ onContinue, disabled, disabledMessage }: ContinueButtonProps) => {
  return (
    <div className="pt-6">
      <Button 
        size="lg" 
        className="w-full max-w-md" 
        onClick={onContinue}
        disabled={disabled}
        title={disabledMessage}
      >
        Continue
        <ChevronRight className="ml-2" />
      </Button>
      {disabled && disabledMessage && (
        <p className="text-sm text-destructive mt-2 text-center">{disabledMessage}</p>
      )}
    </div>
  );
};

export default ContinueButton;
